import React from 'react';
import './ProjectDetailsMobile.css'

function ProjectDetailsMobile(props) {
    // Add safety checks to prevent accessing undefined values
    const slideIndex = typeof props.slideIndex === 'number' ? props.slideIndex : 0;
    const projectMetas = props.projectMetas || [];
    const projectIndex = typeof props.projectIndex === 'number' ? props.projectIndex : 0;
    const fontJsons = props.fontJsons || [];
    const typefaceSwiperIndex = typeof props.typefaceSwiperIndex === 'number' ? props.typefaceSwiperIndex : 0;

    // Make sure we have valid data before accessing nested properties
    let json;
    if (props.selectedPage === 0 && projectMetas[projectIndex] && projectMetas[projectIndex][slideIndex]) {
        json = projectMetas[projectIndex][slideIndex];
    } else if (fontJsons[typefaceSwiperIndex]) {
        json = fontJsons[typefaceSwiperIndex];
    } else {
        // Provide a fallback if data is not available
        json = { title: '', information: '', meta_information: '', additional_information: '', year: '' };
    }

    return (
        <div className='project-details-container-mobile p-4 gap-8 flex flex-col justify-center items-start'>
            <div className='mb-8 overflow-y-scroll'>
                <div className='flex flex-col gap-4'>
                    <div className='font-screen-monitor flex w-full justify-between' style={{ fontSize: '15px' }}>
                        <span>
                            {json.details_title}
                        </span>
                        {!json.additional_information && props.selectedPage === 0 && (
                            <div className='whitespace-nowrap'>
                                {json.year}
                            </div>
                        )}
                    </div>
                    <div>
                        {json.information && (
                            <React.Fragment>
                                <span className='font-screen-monitor' dangerouslySetInnerHTML={{ __html: json.information }} style={{ fontSize: '15px' }}>
                                </span>
                                {json.meta_information && (<React.Fragment>
                                    <br />
                                    <br />
                                </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                        <span>
                            {json.meta_information}
                        </span>
                    </div>
                </div>
                <br />
                <br />
                {json.additional_information && (
                    <div className='font-semi-bold flex gap-4 self-start w-full justify-between'>
                        <div dangerouslySetInnerHTML={{ __html: json.additional_information }} style={{ maxWidth: '50%' }}>
                        </div>
                        <div className='whitespace-nowrap'>
                            {json.year}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProjectDetailsMobile;